import { Link } from "react-router-dom";

import { flagsFor } from "../flags";
import { useLanguage } from "../i18n";
import { photoFor } from "../photos";
import type { Specimen } from "../types";

/**
 * In the collection the photograph *is* the name: a grid of the nine of them is
 * recognisable in a way nine rows of text never were. The three name registers
 * follow underneath, in the same order as everywhere else.
 */
export function SpecimenTile({
  specimen,
  unschedulable,
}: {
  specimen: Specimen;
  unschedulable?: Set<string>;
}) {
  const { t } = useLanguage();
  const arabic = specimen.nickname?.ar || specimen.species.name.ar;
  const photo = photoFor(specimen.species.scientific_name);
  const flags = flagsFor(specimen, t, unschedulable);

  return (
    <li className="plant">
      <Link to={`/plants/${specimen.id}`}>
        {photo && <img className="plant-photo-tile" src={photo} alt="" loading="lazy" />}
        <p className="plant-name" lang="ar">
          {arabic}
        </p>
        <p className="plant-en" dir="ltr">
          {specimen.species.name.en}
        </p>
        <p className="binomial" dir="ltr">
          {specimen.species.scientific_name}
        </p>

        {flags.length > 0 && (
          <ul className="flags">
            {flags.map((flag) => (
              <li key={flag.label} className="flag" data-tone={flag.tone}>
                {flag.label}
              </li>
            ))}
          </ul>
        )}
      </Link>
    </li>
  );
}
